/* global $:false */
(function() {
  'use strict';

  angular
    .module('admin.explore.customfeature', [
      'admin.explore.customfeature.service'
    ])
    .controller('ExploreCustomFeatureCtrl', ExploreCustomFeatureCtrl);

  /** @ngInject */
  function ExploreCustomFeatureCtrl($scope, $state, $stateParams, $q, $timeout, FeaturesService, ExploreCustomFeatureService) {
    var vm = this;
    vm.items = [];
    vm.channels = [];
    vm.sets = [];
    vm.parentId = $stateParams.id;
    vm.readyOnly = false;

    vm.usersPerPage = 10;

    function reloadPagination(){
      vm.totalUsers = 0;
      vm.oldPage = 0;
      vm.currentPage = 10;
      vm.first = true;
      vm.totalItems = 0;
      vm.pagination = {
        current: 1
      };
    }

    reloadPagination();

    load(1);

    function load(pageNumber){
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 10;
        vm.oldPage = vm.currentPage - 10;
      }
      else {
        vm.first = false;
      }

      ExploreCustomFeatureService.listBalbas(vm.parentId, vm.oldPage, 10).then(function(result){
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }

        var items = result.results;
        for (var i = 0; i < items.length; i++) {
          if (pageNumber === 1 && i === 0) {
            items[i].firstRow = true;
          }

          if ((items.length-1) === i && items.length < vm.currentPage) {
            items[i].lastRow = true;
          }
          items[i].edit = false;
        }

        vm.items = items;
      });


    }

    FeaturesService.list().then(function(result){
      vm.banners = result.results;
    });

    vm.add = function(){
      var isPass = true;
      vm.readyOnly = true;
      vm.items.map(function(item){
        if (item.id === 0) {
          swal('You have a row empty fill it first', '', 'warning');
          isPass = false;
          return;
        }
      });
      if (isPass) {
        vm.items.unshift({
          id: 0,
          'id-ch': null,
          'id-s': null,
          edit: true,
        });
      }
    };

    vm.edit = function(item){
      vm.bannerId = item['id-ba'];
      item.edit = !item.edit;
      vm.readyOnly = true;
    };

    vm.save = function(item){
      if (vm.bannerId === undefined || vm.bannerId === null || vm.bannerId === '') {
        swal('You need add banner id field', '', 'warning');
        return;
      }

      var newRow = {
        'id-bl': parseInt(vm.parentId),
        'id-ba': vm.bannerId,
      };

      if (item.id === 0) {
        ExploreCustomFeatureService.createBalbas(vm.parentId, newRow).then(function(){
          vm.bannerId = null;
          vm.readyOnly = false;
          if (vm.items.length === 11) {
            $state.reload();
          } else {
            load(vm.pagination.current);
          }
        });
      } else {
        ExploreCustomFeatureService.updateBalbas(vm.parentId, item.id, newRow).then(function(){
          vm.bannerId = null;
          vm.readyOnly = false;
          if (vm.items.length === 11) {
            $state.reload();
          } else {
            load(vm.pagination.current);
          }
        });
      }
    };

    vm.cancel = function(item){
      swal({
        title: "Are you sure?",
        text: "",
        type: "warning",
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: "slide-from-top"
      }, function(isConfirm){
        if (isConfirm){
          vm.readyOnly = false;
          if (item.id === 0) {
            vm.items.remove(item);
          } else {
            item.edit = !item.edit;
          }
          $scope.$apply();
        } else {
          return;
        }
      });
    };

    vm.delete = function(item){
      swal({
        title: "Are you sure?",
        text: "",
        type: "warning",
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: "slide-from-top"
      }, function(isConfirm){
        if (isConfirm){
          $timeout(function(){
            ExploreCustomFeatureService.removeBalbas(vm.parentId, item.id).then(function(){
              vm.readyOnly = false;
              if (vm.items.length === 1 || vm.items.length === 10) {
                $state.reload();
              } else {
                load(vm.pagination.current);
              }
            }, function(err) {
              vm.readyOnly = false;
              swal(err.error.message, '', 'error');
            });
          }, 250);
        } else {
          return;
        }
      });
    };

    vm.arrowUp = function(item){
      if (item.edit) {
        return;
      }
      var copy = angular.copy(item);
      copy.n = copy.n - 1;
      ExploreCustomFeatureService.updateBalbas(vm.parentId, copy.id, {n: copy.n}).then(function(){
        load(vm.pagination.current);
      });
    };

    vm.arrowDown = function(item){
      if (item.edit) {
        return;
      }
      var copy = angular.copy(item);
      copy.n = copy.n + 1;
      ExploreCustomFeatureService.updateBalbas(vm.parentId, copy.id, {n: copy.n}).then(function(){
        load(vm.pagination.current);
      });
    };

    vm.pageChanged = function(newPage) {
      load(newPage);
    };
  }

})();
